export default {
  baseUrl: '/admin/api'
  // baseUrl: '/hr-web/api'
}
